export function convertSecondsIntoMilliseconds(seconds) {
    return seconds * 1000;
}